export default {
  reportManagement: {
    postReport: 'post举报',
    commentReport: '评论举报',
    fuseList: '评论熔断列表',
    postFuseList: 'post熔断列表',
    pleaseChoose: '请选择语言区',
    pleaseUserId: '请输入用户ID',
    languageArea: '语言区',
    languageAr: '阿拉伯语区',
    languageEn: '英语区',
    languageY: '印尼语区',
    languageTr: '土耳其语区',
    userId: '用户ID',
    username: '用户名称',
    topicName: '话题名称',
    postContent: '内容',
    commentContent: '评论内容',
    image: '图片',
    audio: '音频',
    reportTime: '最早举报时间',
    reportNum: '举报次数',
    reporterId: '举报人id',
    status: '状态',
    operater: '操作人员',
    // ignore: '忽略',
    ignore: '检查通过',
    shield: '屏蔽',
    // ignored: '已忽略',
    ignored: '已检查通过',
    shielded: '已屏蔽',
    cancelShield: '取消屏蔽',
    deleted: '已删除',
    mute: '禁言',
    muted: '已禁言',
    unMute: '解除禁言 禁言到期时间: {date}',
    operatRole: '操作人角色',
    role1: '审核人员',
    role2: '超管',
    role3: '后台管理员',
    role4: '国家管理员',
    showBigImg: '查看大图',
    operatTime: '操作时间',
    checkCancelShield: '确认执行取消屏蔽操作',

    deleteAndBan:'删除并禁言',
    deleteAndBanId:'删除并封禁ID',
    batchDelete:'批量删除',
    batchIgnore:'批量忽略',
    delete:'删除',
    pleaseChooseContent:'请选择内容',
    sureAction:'确认对所选项目进行 {action}吗',
  },
  contentReview: {
    chooseLanguage: '请选择语言区',
    choosePost: '请选择post状态(默认为空)',
    chooseUserId: '请输入用户ID',
    languageArea: '语言区',
    languageAr: '阿拉伯语区',
    languageEn: '英语区',
    languageY: '印尼语区',
    languageTr: '土耳其语区',
    userId: '用户ID',
    nickname: '用户名称',
    topicName: '话题名称',
    postContent: 'post内容',
    votingOptionsContent: '投票选项内容',
    topicImg: '图片',
    audio: '音频',
    createTime: '创建时间',
    commentAndGood: '评论数/点赞数',
    commentsNum: '评论数',
    goodNum: '点赞数',
    operaUser: '操作用户',
    recommend: '推荐',
    shield: '屏蔽',
    search: '搜索',
    wait: '待审核',
    process: '审核通过',
    notPassed: '审核不通过',
    pleaseChoose: '请选择',
    unrecommend: '不推荐',
    shenPost: '沉贴',
    shenPosted: '已沉贴',
    unshield: '解除屏蔽',
    recommended: '已推荐',
    systemRecome: '系统推荐',
    shielded: '已屏蔽',
    cancalShielded: '取消屏蔽',
    deleted: '已删除',
    postId: '帖子id',
    seeType: '可见类型',
    visibleToAll: '所有人可见',
    followSee: '关注即可见',
    mutualVisible: '互相关注可见',
    private: '私人，仅po主可见',
    topText: '置顶',
    chooseTopTime: '选择置顶时间',
    pleaseChooseTime: '请选择时间',
    pleaseEnterTime: '请输入置顶时间',
    topTimeTo: '置顶至{time}',
    checkCancelTop: '确认取消置顶',
    privatePost: '私人帖子不可修改',
  },
  albumReview: {
    pageText1: '头像审核',
    status: '状态',
    pageText2: '批量通过',
    pageText3: '批量拒绝',
    pageText4: '确认执行通过操作?',
    pageText5: '确认执行拒绝操作?',
    pageText6: '待审核',
    pageText7: '已审核',
    pageText8: '已拒绝',
    pageText9: '违规处理记录',
    pageText10: '忽略记录',

    pageText11:'确认执行警告后删除吗？',
    pageText12:'确认禁止发帖吗？',
  },
  topicReview: {
    search1: '分区',
    search2: '分类',
    search3: '用户id',
    search4: '待审核',
    search5: '拒绝',
    search5_1: '已删除',
    search6: '状态',
    tab1: '未审核',
    tab2: '已审核',
    tableText1: '语言区',
    tableText2: '话题分类',
    tableText3: '用户id',
    tableText4: '用户名称',
    tableText5: '话题名称',
    tableText6: '话题介绍',
    tableText7: '话题图片',
    tableText8: '申请时间',
    tableText9: '操作人员',
    tableText10: '操作时间',
    tableText11: '用户国家',
    tableText12: '批量删除',
    tableText13: '批量通过',
    tableText16: '批量拒绝',
    tableText14: '社区禁言&拒绝',
    tableText15: '封禁id&拒绝',
    warnText1: '确认执行通过操作',
    warnText2: '确认执行拒绝操作',

    btnText1:'警告后拒绝',
    btnText2:'禁止发帖',
  },
  communityAnomaly: {
    resetData: '重置资料',
    banId: '封禁id',
    banDevice: '封禁设备',
    // ignore: '忽略',
    ignore: '检查通过',
    enterUserId: '请输入用户靓号id',
    mute: '禁言',
    muted: '已禁言',
    unMute: '解除禁言',
    tabText1: '社区异常记录',
    tabText2: '封禁记录',
    enterIdInvalid: '输入的id无效',
    userId: '用户靓号',
    inTotal: '共有{num}个账号',
    ignoreText: '确认忽略举报信息？',
    userIdText: '用户ID',
    oneMinComment: '1分钟评论次数',
    userLevel: '用户等级',
    registerTime: '注册时间',
    registerIp: '注册ip',
    country: '国家',
    clickShowText: '点击查看',
    operatTime: '操作时间',
    operatContent: '操作内容',
    operaUser: '操作人',
    // ignored: '已忽略',
    ignored: '已检查通过',
    ban12hed: '已封禁广播12h',
    banDeviced: '已封禁设备',
    banIded: '已封禁id',
    reseted: '已重置资料',
    contentList: '回复内容列表',
    contentDelAll: '全部删除',
    replyContent: '回复内容',
    choose: '选择',
    delSelect: '删除选中回复',
    delSelectCheck: '确认删除选中回复',
    deleted: '已删除',
    status: '状态',
    muteAlreadyOut: '禁言已解除',
    muteTime: '禁言到期时间',
  },
  broadcastManagement: {
    enterId: '请输入用户靓号id',
    userLiangId: '用户靓号',
    areaSearch: '地区搜索',
    tabText1: '已审核',
    tabText2: '未审核',
    // ignore: '忽略',
    ignore: '检查通过',
    ban12h: '封禁广播12h',
    banBtn: '封禁广播',
    banDevice: '封禁设备',
    banId: '封禁ID',
    selectAll: '全选',
    choose: '选择',
    country: '国家',
    userId: '用户ID',
    username: '用户昵称',
    broadcastContent: '广播内容',
    operaTime: '操作时间',
    sendTime: '发布时间',
    operaer: '操作人',
    operatContent: '操作内容',
    // ignored: '已忽略',
    ignored: '已检查通过',
    deleted: '已删除',
    ban12hed: '已封禁广播12h',
    banBtned: '已封禁广播',
    banDeviced: '已封禁设备',
    banIded: '已封禁id',
    araArea: '阿语区',
    enArea: '英语区',
    turArea: '土耳其区',
    indArea: '印尼语区',
    level: '等级',
    registraTime: '注册时间',
    registerIp: '注册IP',
    inTotal: '共有{num}个账号',
    selectText1: '广播',
    selectText2: '粉丝召集',
    selectText3: '成员召集',
    selectText4: '公会召集',
    selectText5: '未审核',
    selectText6: '已审核',
    selectText7: '已删除',
    convenedContent: '召集内容',
    area: '区域',
    table1Text1: '审核昵称',

    table1Text2: '等待时长',
    table1Text3: '审核时间',
    table1Text4: '审核人ID',
  },
}



// WEBPACK FOOTER //
// ./src/language/community.js